import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "inline-block",
      position: "relative",
    },
    iconButton: {
      padding: 0,
      position: "relative",
      zIndex: 1,
    },
  })
);
